import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { BuildingBlockResolverComponent } from './building-block-resolver.component';

// tslint:disable-next-line: completed-docs
@NgModule({
  declarations: [BuildingBlockResolverComponent],
  exports: [BuildingBlockResolverComponent],
  imports: [CommonModule]
})
export class ResolverModule {}
